import React from 'react';
import { Route, Switch } from 'react-router-dom';
import UserComponent from './user_management/UserComponent';
import UserAccessComponent from './user_management/UserAccessComponent'
import AdminSideBar from './AdminSideBar';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import SettingParent from './header/SettingParent';
import Home from "./Home";
import Synonym from './synonym/Synonym';
import AuthIntegration from './integration/AuthIntegration';
import DataMerge from './datamanagement/DataMerge';
import MetricComponent from './derivedkpi/MetricComponent';
import LogComponent from './log/LogComponent';
import DBManagementComponent from './table_management/DBManagementComponent';
import DBManagementComponentOld from './table_management/DBManagementComponentOld';
import DatasetComponent from './dataupload/DatasetComponent';

import SegmentComponent from './segment/SegmentComponent';
import ColumnDefinitionComponent from './columnDefinition/ColumnDefinitionComponent';
import MetricFormatComponent from '../components/metricformat/MetricformatComponent';
import DefaultSettings from '../components/default/DefaultSettings';
import BreadCrumb from './commonComponents/BreadCrumb';
import SettingComponent from '../../src/components/SettingComponents/setting';
import RawComponent from './raw_table/RawComponent';
class AdminParent extends React.Component {
    constructor(props) {
        super(props)
        this.state = { ...props, tableFlag: false }

        this.menu_array = {
            "home": { "name": "home", "label": 'Home', "link": "/admin/home", "icon": "home", "showMenu": false },
            // "datasets":{ "name": "datasets","label": 'Datasets', "link": "/admin/dataset", "icon": 'upload' },
            "dataConnector": { "name": "dataConnector", "label": 'Data Connectors', "link": "/adminpanel/v2/dataconnector", "icon": "sliders", "showMenu": false },
            "addConnection": { "name": "addConnection", "label": 'Add Connection', "link": "/adminpanel/v2/initialize_connector", "icon": "plus-circle", "showMenu": false },
            "connectionsData": { "name": "connectionsData", "label": 'All Connections Data', "link": "/adminpanel/v2/view_connection_data", "icon": "server", "showMenu": false },
            "apiRequest": { "name": "apiRequest", "label": 'Request Logs', "link": "/adminpanel/v2/apirequest/admin", "icon": "activity", "showMenu": false },
            "dataSettings": {
                "name": "dataSettings", "label": 'Data Settings', "link": "javascript:void(0);", "icon": "database",
                "children": {
                    // "data": { "name": "db_management", "label": 'Upload Files (Storage)', "link": "/admin/upload_data", "header": "Data", "showMenu": false },
                    "createView": {
                        "name": "createView", "label": 'Create Dataset', "link": "/admin/datasets", "header": "Data", "showMenu": false
                    },
                    "listView": { "name": "datasets", "label": 'Merge Tables', "link": "/admin/merge", "showMenu": false },
                    "savedModel": {"name": "savedModel", "label": "Saved Model", "link": "/adminpanel/v2/savedModel", "showMenu": false}
                }
            },

            "buildDataModal": {
                "name": "buildDataModal", "label": 'Ad-Hoc Settings', "link": "javascript:void(0);", "icon": "pie-chart",
                "children": {
                    "column_definition": { "name": "column_definition", "label": 'Column Definition', "link": "/admin/model_data", "showMenu": true },

                    "dimensions": { "name": "dimensions", "label": 'Add Segments', "link": "/admin/dimensions", "showMenu": true },
                    "metrics": { "name": "metrics", "label": 'Add Metrics', "link": "/admin/metric", "header": "Configure Ad-Hoc BI", "showMenu": true },
                    "metricformat": { "name": "metricformat", "label": 'Metric Formatting', "link": "/admin/metricformat", "showMenu": true },
                }
            },
            "cognitiveSettings": {
                "name": "cognitiveSettings", "label": 'Cognitive Settings', "link": "javascript:void(0);", "icon": "search",
                "children": {
                    "synonyms": {
                        "name": "synonyms", "label": 'Configure Search', "link": "/admin/synonym?type=property", "showMenu": true
                        // "children": {
                        //     "synonym_property": { "name": "synonym_property", "label": "Dimension Synonyms", "link": "/admin/synonym?type=property", "icon": 'paperclip', "showMenu": true},
                        //     "synonym_metric": { "name": "synonym_metric", "label": "Metric Synonyms", "link": "/admin/synonym?type=metric", "icon": 'crop', "showMenu": true }
                        // }
                    },

                    "configInsight": {
                        "name": "insight", "label": 'Configure Insight', "link": "/admin/configureInsight", "showMenu": true
                    },
                }
            },
            "users": {
                "name": "users", "label": 'User Management', "link": "javascript:void(0);", "icon": "users",
                "children": {
                    "manageUsers": { "name": "manageUsers", "label": "Manage Users", "link": "/admin/users", "showMenu": false },
                    "managePermissions": { "name": "managePermissions", "label": "User Permissions", "link": "/admin/useraccess", "showMenu": false }
                }
            },
            "settings": { "name": "settings", "label": 'Navbar Settings', "link": "/admin/setting", "icon": "settings" },
            "generalsettings": { "name": "generalsettings", "label": 'General Settings', "link": "/admin/generalsettings", "icon": "settings" },
            "authIntegrate": { "name": "authIntegrate", "label": 'Configure Authentication', "link": "/admin/authIntegrate", "icon": "settings", "showMenu": false },
            //"emailIntegrate": { "name": "emailIntegrate", "label": 'Configure Email', "link": "/adminpanel/v2/emailIntegrate", "icon": "settings", "showMenu": false },
            "App": { "name": "app", "label": 'Rockmetric App', "link": "/", "icon": "home", "showMenu": false }
        };

        if (!localStorage.Dataset && props.authData) {
            let tempJson = { siteId: props.authData.siteId };
            localStorage.setItem("Dataset", JSON.stringify(tempJson));
        }
    }

    componentDidUpdate(prevProps, nextState) {
        feather.replace()
        if (prevProps.toolId !== this.props.toolId) {
            this.setState({
                toolId: this.props.toolId
            })
        }
    }

    handleClick = () => {
        if (this.state.open) {
            this.setState({
                open: false
            })
        } else {
            this.setState({
                open: true
            })
        }
    }

    setTitle() {
        var pathName = location.pathname;
        pathName = pathName.split("/");
        if (pathName.length == 4)
            pathName = pathName[2];
        else pathName = pathName[pathName.length - 1];
        let title = "";
        switch (pathName) {
            case "admin":
                title = "Admin"
                break;
            case "home":
                title = "Home"
                break;
            case "datasets":
                title = "Datasets"
                break;
            case "generalsettings":
                title = "Settings"
                break;
            case "merge":
                title = "Merge Tables"
                break;
            case "model_data":
                title = "Column Definition"
                break;
            case "dimensions":
                title = "Segments"
                break;
            case "metric":
                title = "Metrics"
                break;
            case "metricformat":
                title = "Metric Format"
                break;
            case "synonym":
                title = "Configure Search"
                break;
            case "configureInsight":
                title = "Configure Insight"
                break;
            case "users":
                title = "Users"
                break;
            case "useraccess":
                title = "User Permissions"
                break;
            case "authIntegrate":
                title = "Authentication"
                break;
        }
        document.title = `${title} | Cognitive Analytics Platform`;
    }

    screen_width = jQuery(window).width() 
    render() {
        if (!this.props.authData || !this.props.authData.userId) {
            return (
                <Redirect to="/login" />
            )
        }
        this.setTitle();
        return (
            <div>
                <AdminSideBar match={this.props} menuOptions={this.menu_array} tableData={this.props.tableData} />
                <div className={`${this.screen_width<mobile_width? ' ht-100v pd-0':'content ht-100v pd-0 adminParentMargin'}`} >
                    {<nav class="content-header d-none mobile-d-none bg-white bd-b-1" style={{ borderBottomWidth: "1px", }}> </nav>}
                    {/* <div className="content-header">
                        <div className="content-search">
                            <i data-feather="search"></i>
                            <input type="search" className="form-control" placeholder="Search..." />
                        </div>
                    </div> */}

                    <div className="content-body" ref={(node) => {
                        if (node) {
                            node.style.setProperty("padding", "25px", "important");
                        }
                    }}>

                        <BreadCrumb menuOptions={this.menu_array} pathname={this.props.location.pathname} />

                        <Switch>

                            <Route exact path={`/`} render={(props) => <Home {...props} menuOptions={this.menu_array} />} />
                            <Route exact path={`/admin`} render={(props) => <Home {...props} menuOptions={this.menu_array} />} />
                            <Route exact path={`/admin/home`} render={(props) => <Home {...props} menuOptions={this.menu_array} />} />

                            <Route path={`/admin/upload_data_new`} render={(props) => <DBManagementComponent {...props} datasetValue={this.state.toolId} authData={this.props.authData} />} />
                            <Route path={`/admin/upload_data`} render={(props) => <DBManagementComponentOld {...props} datasetValue={this.state.toolId} authData={this.props.authData} />} />


                            <Route exact path={`/admin/datasets`} render={(props) => <DatasetComponent {...props} menuOptions={this.menu_array} />} />
                            <Route exact path={`/admin/users`} render={(props) => <UserComponent {...props} datasetValue={this.state.toolId} authData={this.props.authData} />} />
                            <Route exact path={`/admin/useraccess`} render={(props) => <UserAccessComponent {...props} datasetValue={this.state.toolId} authData={this.props.authData} />} />
                            {/* <Route exact path={`/admin/groups`} render={(props) => <GroupComponent {...props} datasetValue={this.state.toolId} authData={this.props.authData} />} /> */}
                            <Route path={`/admin/setting`} component={SettingComponent} />
                            <Route exact path={`/admin/authIntegrate`} component={AuthIntegration} />
                            {/* <Route exact path={`/admin/settings`} component={DefaultSetting} /> */}
                            {/* <Route exact path={`/admin/defaultsettings`} render={(props) => <DefaultSetting {...props} datasetValue={this.state.toolId} authData={this.props.authData} />} /> */}
                            <Route exact path={`/admin/generalsettings`} render={(props) => <SettingParent {...props} datasetValue={this.state.toolId} authData={this.props.authData} />} />
                            {/* <Route exact path={`/admin/defaultsettings`} render={(props) => <DefaultSettings {...props} datasetValue={this.state.toolId} authData={this.props.authData} />} /> */}
                            <Route exact path={`/admin/configureInsight`} render={(props) => <DefaultSettings {...props} datasetValue={this.state.toolId} authData={this.props.authData} />} />
                            <Route exact path={`/admin/synonym`} render={(props) => <Synonym {...props} datasetValue={this.state.toolId} authData={this.props.authData} />} />
                            <Route exact path={`/admin/metricformat`} render={(props) => <MetricFormatComponent {...props} datasetValue={this.state.toolId} authData={this.props.authData} />} />

                            <Route exact path={`/admin/merge`} component={DataMerge} />
                            {/* Code Ended */}

                            {/*  Code added by Varun Bhandia, Migration of Derived KPI module */}
                            <Route exact path={`/admin/metric`} render={(props) => <MetricComponent {...props} datasetValue={this.state.toolId} authData={this.props.authData} />} />
                            <Route exact path={`/admin/raw_data`} render={(props) => <RawComponent {...props} datasetValue={this.state.toolId} authData={this.props.authData} />} />
                            <Route exact path={`/admin/logs`} render={(props) => <LogComponent {...props} datasetValue={this.state.toolId} authData={this.props.authData} />} />
                            <Route exact path={`/admin/dimensions`} render={(props) => <SegmentComponent {...props} datasetValue={this.state.toolId} authData={this.props.authData} />} />

                            {/*  Code Ended */}

                            {/*  Code added by Varun Bhandia, Column Defination module */}
                            <Route exact path={`/admin/model_data`} render={(props) => <ColumnDefinitionComponent {...props} datasetValue={this.state.toolId} authData={this.props.authData} />} />

                            {/*  Code Ended */}
                            {/* <Route exact path={`/admin/insights`} render={(props) => <InsightConfiguration {...props} datasetValue={this.state.toolId} authData={this.props.authData} />} /> */}
                        </Switch>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        toolId: state.admin.toolId,
        authData: state.dataSet.authData
    };
}

// function mapDispatchToProps(dispatch) {
//     return bindActionCreators({getToolId
//     }, dispatch);
// }

export default connect(mapStateToProps, null)(AdminParent);
// export default AdminParent;